var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aha-icon',_vm._b({attrs:{"name":_vm.logoType,"maintainColor":_vm.useDefaultColor,"viewBox":_vm.viewBox}},'aha-icon',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }